import type { JobAdsRequestParameters } from "@/modules/jobAds/client/utils/computeJobAdsRequest"

import { JOB_ADS_QUERY_KEY } from "./constants"

export function getJobAdsFromESQueryKeys({
  companyIds,
  contractDurations,
  contractTypes,
  curriculumIds,
  locations,
  page,
  positionCategories,
  schoolId,
  startDates,
  studyLevels,
  userQuery,
  exclusive,
  tags,
  locales,
  companySectors,
}: Omit<JobAdsRequestParameters, "studyLevelsSearchConfig" | "contractTypesSearchConfig">): (unknown | null)[] {
  return [
    JOB_ADS_QUERY_KEY,
    companyIds || [],
    contractDurations || null,
    contractTypes || null,
    curriculumIds || [],
    locations || null,
    page || null,
    positionCategories || null,
    schoolId || null,
    startDates || null,
    studyLevels || null,
    studyLevels || null,
    userQuery || null,
    exclusive || null,
    tags || null,
    locales || null,
    companySectors || null,
    "withES",
  ]
}
